import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";

const useGetCensusParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const year =
    searchParams.get(CensusUrlKeys.YEAR) ?
      Number(searchParams.get(CensusUrlKeys.YEAR))
    : null;

  const outputAreaId =
    searchParams.get(CensusUrlKeys.OUTPUT_AREA) ?
      Number(searchParams.get(CensusUrlKeys.OUTPUT_AREA))
    : null;

  const categoryId =
    searchParams.get(CensusUrlKeys.CATEGORY) ?
      Number(searchParams.get(CensusUrlKeys.CATEGORY))
    : null;

  const columnId =
    searchParams.get(CensusUrlKeys.COLUMN) ?
      Number(searchParams.get(CensusUrlKeys.COLUMN))
    : null;

  const handleSelect = useCallback(
    (key: CensusUrlKeys, value: number | null) => {
      if (value === null) return;

      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set(key, String(value));

        if (key === CensusUrlKeys.YEAR) {
          newParams.delete(CensusUrlKeys.OUTPUT_AREA);
          newParams.delete(CensusUrlKeys.CATEGORY);
          newParams.delete(CensusUrlKeys.COLUMN);
        }

        if (key === CensusUrlKeys.CATEGORY) {
          newParams.delete(CensusUrlKeys.COLUMN);
        }

        return newParams;
      });
    },
    [setSearchParams],
  );

  const clearParam = useCallback(
    (...keys: CensusUrlKeys[]) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        keys.forEach((key) => newParams.delete(key));
        return newParams;
      });
    },
    [setSearchParams],
  );

  return {
    year,
    outputAreaId,
    categoryId,
    columnId,
    handleSelect,
    clearParam,
  };
};

export default useGetCensusParams;
